<template>
  <div class="h-screen flex flex-col items-center justify-center px-4 md:px-8">
    <div class="relative mx-auto max-w-2xl w-full">
      <div
        class="relative h-[400px] rounded-3xl bg-blue-500 brand-card-shadow flex flex-col items-center justify-center gap-4 p-8"
        :style="{
          backgroundImage:
            'radial-gradient(circle at 1px 1px, rgba(255, 255, 255, 0.15) 1px, transparent 0)',
          backgroundSize: '10px 10px',
          imageRendering: 'pixelated',
        }"
      >
        <h1 class="text-8xl font-bold relative z-10 text-white">404</h1>

        <h2 class="text-3xl font-semibold relative z-10 text-white">
          Page not found
        </h2>

        <p class="text-center text-base text-white/80 relative z-10 max-w-md">
          Sorry, we couldn't find the page you're looking for.
        </p>

        <!-- Bottom content -->
        <div class="mt-6">
          <Button
            class="transition-all duration-300 z-10 ease-out hover:scale-102 hover:shadow-xl hover:brightness-110 active:scale-100 brand-button-shadow"
            @click="router.push('/')"
          >
            ← Back to home
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from "@/components/ui/button";
import { useRouter } from "vue-router";

const router = useRouter();
</script>
